<template>
  <WsRead
    :modelName="modelName"
    :id="$route.params.id"
    :localeMode="localeMode"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    :secondary="pageSetting.secondary"
    titleKey="name"
    :getTitle="_getTitle"
    :customBtns="_customBtns"
    @input="$_onInput($event)"
  >
  </WsRead>
</template>

<script>
import model from "@/models/broadcast";
export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    localeMode: true,
    fields: model.fields,
    state: {},
    pageSetting: {
      primary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "快報資訊",
              fields: ["locales", "attaches"],
            },
            {
              title: "發布資訊",
              fields: ["announce_at"],
            },
          ],
        },
      ],
      secondary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "設定",
              fields: [
                "areas",
                "industry_categories",
                "system_classes",
                "system_subclasses",
              ],
            },
          ],
        },
        {
          type: "infoCard",
          floors: [
            {
              title: "建立資訊",
              fields: ["created_at", "created_admin"],
            },
          ],
        },
        {
          type: "infoCard",
          floors: [
            {
              title: "編輯資訊",
              fields: ["updated_at", "updated_admin"],
            },
          ],
        },
      ],
    },
  }),
  methods: {
    $_onInput($event) {
      this.state = $event;
    },
  },
  computed: {
    _selectingLocale() {
      return this.$store.state.locale.selectingLocale;
    },
    _getTitle() {
      return function (data) {
        if (data.locales && data.locales[this._selectingLocale]) {
          return data.locales[this._selectingLocale][this.titleKey];
        } else {
          return "";
        }
      };
    },
    _customBtns() {
      return [
        {
          title: "查看發布集團工廠",
          color: "textSecondary",
          outlined: true,
          icon: "mdi-factory",
          to: `/${this.modelName}/${this.$route.params.id}/multi-list?factories=${this._stringFactories}`,
        },
      ];
    },
    _stringFactories() {
      if (!this.state || !this.state.factories || !this.state.factories.length)
        return "";
      return this.state.factories.map((item) => item.id).toString();
    },
  },
};
</script>